import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { Sparkles, ShieldCheck } from 'lucide-react';
const includes = ['Plan de 21 Días completo (5 capítulos + 3 herramientas)', 'Bono 1: Reset 50+, De Agotada a Encendida en 72h', 'Bono 2: SOS Hormonal, Menú Anticrisis en 5 min', 'Bono 3: Ritual Matutino, 5 minutos que reactivan', 'Garantía de 7 días · Riesgo cero'];
export const FinalCTASection = () => {
  return <Section bg="bg-cream-dark/30" className="border-t border-cream-dark" data-id="element-182">
      <FadeIn data-id="element-183">
        <div className="max-w-3xl mx-auto text-center" data-id="element-184">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-brown" data-id="element-185">
            Ya esperaste suficiente.{' '}
            <span className="text-gold italic font-normal" data-id="element-186">
              Hoy es tu turno.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-brown-light leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-187">
            Miles de mujeres siguen aguantando porque nadie les dijo que existía
            otra opción. Tú ya lo sabes.
          </p>

          <div className="bg-white border border-cream-dark rounded-3xl p-8 md:p-10 shadow-sm mb-10 text-left max-w-xl mx-auto" data-id="element-188">
            <ul className="space-y-4" data-id="element-189">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-brown" data-id="element-190">
                  <Sparkles className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-191" />
                  <span className="leading-relaxed" data-id="element-192">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-6 flex items-center justify-center gap-2 text-sage font-bold" data-id="element-193">
            <ShieldCheck className="w-5 h-5" data-id="element-194" />
            <span className="text-sm" data-id="element-195">Garantía de 7 días sin riesgo</span>
          </div>

          <Button className="mx-auto" href="https://pay.hotmart.com/W105376697A?checkoutMode=10" onClick={() => {
          try {
            const fbq = (window as any).fbq;
            if (fbq) fbq('track', 'AddToCart', {
              currency: 'USD',
              value: 17,
              content_name: 'Plan de 21 Días de Vitalidad Menopáusica',
              content_type: 'product'
            });
          } catch (e) {}
        }} data-id="element-196">
            ✨ SÍ, QUIERO EMPEZAR HOY — $17 USD
          </Button>

          <p className="mt-6 text-sm text-brown-light/70" data-id="element-197">
            🔒 Pago seguro · Acceso instantáneo · Tu nueva vitalidad comienza
            mañana
          </p>
        </div>
      </FadeIn>
    </Section>;
};